module.exports = __webpack_public_path__ + "img/ic_drop_down.8763785a.svg";